
import { Component, Vue, Prop } from 'vue-property-decorator';
import LinkableLabel from '../shared/LinkableLabel.vue';

@Component({
    components: {
        LinkableLabel,
    },
})
export default class ResultsRow extends Vue {
    @Prop() isVisible!: boolean;
    @Prop() labelId!: string;
    @Prop() resultId!: string;
    @Prop() labelText!: string;
    @Prop() resultValue!: string;
    @Prop({ default: false }) hasLink!: boolean;
    @Prop() popoverType!: string;

    @Prop({ default: '' }) glyphSymbol!: string;
    @Prop() glyphAlign!: string;
    @Prop() glyphAriaDescription!: string;

    cyResultId = '';

    created(){
        this.cyResultId = this.resultId + '-cy';
    }

    get hasResult() {
        return this.resultValue !== undefined && this.resultValue.length > 0;
    }

    get hasGlyph() {
        return this.glyphSymbol !== undefined && this.glyphSymbol.length > 0;
    }

    get leadingGlyph() {
        return this.hasGlyph && this.hasResult && this.glyphAlign == 'left' ? this.glyphSymbol : '';
    }

    get trailingGlyph() {
        return this.hasGlyph && this.hasResult && this.glyphAlign == 'right' ? this.glyphSymbol : '';
    }
}
